module.exports = __webpack_public_path__ + "static/media/iphone_airpods_dark.a11f1469.svg";